import { useEffect, useState } from "react";
import Card from "../UI/Card";
import MealItem from "./MealItem/MealItem";
import classes from "./AvailableMeals.module.css";

const AvailableMeals = () => {
	const [allMeals, setAvailableMeals] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [httpError, setHttpError] = useState();

	useEffect(() => {
		const fetchMeals = async () => {
			const response = await fetch(
				"https://foodfetch-582bf-default-rtdb.firebaseio.com/meals.json"
			);

			if(!response.ok) {
				throw new Error('Something is wrong.')
			}

			const responseData = await response.json();

			const loadedMeals = [];

			for (const key in responseData) {
				loadedMeals.push({
					id: key,
					name: responseData[key].name,
					description: responseData[key].description,
					price: responseData[key].price,
				});
			}
			setAvailableMeals(loadedMeals);
			setIsLoading(false);
		};
			fetchMeals().catch((error)=>{
			setIsLoading(false);
			setHttpError(error);
		})
	}, []);

	if (isLoading === true) {
		return <p className={classes.loading}>Loading....</p>;
	}

	if(httpError) {
		<section className={classes.mealsError}>{httpError}</section>
	}

	const mealsList = allMeals.map((meal) => (
		<MealItem
			key={meal.id}
			id={meal.id}
			name={meal.name}
			description={meal.description}
			price={meal.price}
		/>
	));

	return (
		<section className={classes.meals}>
			<Card>
				<ul>{mealsList}</ul>
			</Card>
		</section>
	);
};

export default AvailableMeals;
